module.exports = __webpack_public_path__ + "img/icon_jrcg.eed224e7.png";